import request from '@/utils/service'

export function getCategories(data, locale) {
  return request({ url: 'meta-tag/list', data, locale })
}

export function updateCategory(data, locale) {
  return request({ url: 'meta-tag', data, locale })
}

export function deleteCategory(id, locale) {
  return request({ url: `meta-tag/delete/${id}`, locale })
}
